const n=new Set(["none","hidden"]);function e(e,t){return n.has(e)?n=>n<=0?e:t:n=>n>=1?t:e}export{n as invisibleValues,e as mixVisibility};
